import type { FieldsetProps } from '@pearlconvert/ui/components/fieldset/fieldset.types'

import React from 'react'

import '@pearlconvert/ui/components/fieldset/styles/fieldset.scss'

const Fieldset: React.FC<FieldsetProps> = ({ legend, children, className }) => {
  return (
    <fieldset className={`fieldset${className ? ' ' + className : ''}`}>
      {legend && <legend>{legend}</legend>}
      {children}
    </fieldset>
  )
}

export default Fieldset
